import './KrisPlayer.scss'

import { useEffect } from 'react';

const unused_0 = 'meowmeowmeowmeowmeowmeowmeowmeowmeowmeowmeow ;PPP'

function KrisPlayer() {
  const loop = () => {
    const video = document.querySelector('video')
    setTimeout(() => {
      video.addEventListener('ended', () => {
        video.play()
      })
    }, 100)
  }

  const viewCounter = () => {
    setTimeout(() => {
      const video = document.querySelector('video')
      video.addEventListener('play', () => {
        if (video.currentTime === 0) {
          if (!localStorage.getItem('viewCount')) {
            localStorage.setItem('viewCount', 1)
            document.getElementById('view-count').innerHTML = localStorage.getItem('viewCount')
            holyFuckExtremeMeasuresHaveBeenTakenToAppeaseLikeOnePerson2()
          } else {
            localStorage.setItem('viewCount', Number(localStorage.getItem('viewCount')) + 1)
            document.getElementById('view-count').innerHTML = localStorage.getItem('viewCount')
            holyFuckExtremeMeasuresHaveBeenTakenToAppeaseLikeOnePerson2()
          }
        }
      })
    }, 100)
  }

  // toggle an `S` after the word view in the DOM
  const holyFuckExtremeMeasuresHaveBeenTakenToAppeaseLikeOnePerson2 = () => {
    if (localStorage.getItem('viewCount') == 0 || localStorage.getItem('viewCount') >= 2 || !localStorage.getItem('viewCount')) {
      document.getElementById('plural-toggle').innerHTML = ' views '
    } else {
      document.getElementById('plural-toggle').innerHTML = ' view '
    }
  }

  return (
    <div id="kris">
      <div className="views">
        <p id="view-count">{localStorage.getItem('viewCount') ? localStorage.getItem('viewCount') : "How... many... "}</p>
        <p id="plural-toggle"> views </p>
        <p>from this <span>Device</span>...</p>
      </div>
      <video src="kris.mp4" controls />
      { useEffect(() => loop())}
      { useEffect(() => viewCounter())}
    </div>
  )
}

export default KrisPlayer